const Builder = require('../BuilderBase');

module.exports = class TabAfterScan extends Builder {
    constructor(properties) {
        super('transform_TabAfterScan', '', properties);
    }
};
